import type { OrderForm } from '../typings'
import { UNSYNC_ORDER_FORM_VALUE, DEFAULT_ORDER_FORM_ID } from '../constants'

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

const orderFormOptimizationEnabled =
  (canUseDOM &&
    (window as any)?.__RUNTIME__?.settings?.['vtex.store']
      ?.enableOrderFormOptimization) ??
  false

/**
 * Heuristic function to determine whether or not the local
 * order form (stored in localStorage) should be replaced by
 * the remote order form.
 */
export const shouldUpdateOrderForm = (
  localOrderForm: OrderForm,
  remoteOrderForm: OrderForm
): boolean => {
  return (
    localOrderForm.value === UNSYNC_ORDER_FORM_VALUE ||
    (orderFormOptimizationEnabled &&
      localOrderForm.id !== remoteOrderForm.id &&
      localOrderForm.id !== DEFAULT_ORDER_FORM_ID)
  )
}
